import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useAuth } from './hooks/useAuth';

interface ProtectedRouteProps {
  allowedRoles?: ('USER' | 'ADMIN')[];
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles, children }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to. This allows us to send them along to that page after they login.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If allowedRoles are specified, check if the user's role is included.
  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    // User is authenticated but not authorized for this route.
    return (
      <Result status="403" title="403" subTitle="Sorry, you are not authorized to access this page." extra={<Button type="primary" href="/">Back Home</Button>} />
    );
  }

  // If children are provided, render them. Otherwise, render the Outlet for nested routes.
  // This makes the component flexible for both single-route and layout protection.
  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;